"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('cc', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2782 12.14C21.181 12.4803 22.9856 12.9636 24.6924 13.59C21.8825 13.6074 19.0791 14.7782 17.0541 17.1031L16.8557 17.338C14.0164 20.8064 13.8258 25.7794 16.2839 29.4497L16.2224 29.3375C18.7497 33.9806 23.0519 38.0543 27.499 39.3643C31.0799 40.4191 34.4305 40.699 37.5178 40.1993L37.5447 40.1811C33.8191 43.0921 29.3272 44.5531 24.831 44.5657H24.7149L24.2838 44.56C18.9676 44.4356 13.6883 42.2862 9.70805 38.1145L9.37863 37.761C5.80885 33.8396 4.01583 28.845 4 23.8458V23.7129L4.00633 23.2585C4.09466 19.6852 5.09141 16.1308 6.99642 12.9861L6.9277 13.0053C11.431 11.7595 15.5469 11.4727 19.2782 12.14ZM29.8165 32.6329C31.3625 31.897 33.2256 32.2538 34.4485 33.4762L39.4604 38.4856L39.1209 38.8175C39.0934 38.8438 39.0659 38.8699 39.0383 38.896C35.6475 39.8088 31.8914 39.663 27.7688 38.4487C24.7892 37.571 22.2332 35.4185 19.9509 32.7705L19.9015 32.7432C22.9258 34.3814 26.604 34.3771 29.6249 32.7306L29.8165 32.6329ZM24.7544 3L25.1975 3.00478C30.3656 3.11524 35.5015 5.14203 39.4455 9.08605L34.4485 14.0831L34.2924 14.2313C33.0178 15.3812 31.1429 15.6555 29.6249 14.8282L29.3639 14.6908C29.3141 14.6656 29.2642 14.6408 29.2142 14.6164C26.2909 12.9806 23.0341 11.842 19.4463 11.2004C15.8761 10.5619 11.9853 10.7621 7.77611 11.797C8.35234 10.9769 8.99698 10.1902 9.70805 9.44478L10.0345 9.11005C14.0951 5.03684 19.4211 3 24.7495 3H24.7544Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5495 17.3254L33.6599 21.8806L33.444 22.0289C33.444 22.0289 32.7685 22.4815 32.8431 23.4386C32.9084 24.2756 33.5048 24.6289 33.5048 24.6289L41.7353 29.3769C41.7353 29.3769 42.3801 29.7247 43.1816 29.2914C44.0779 28.8067 44.0166 27.8599 44.0166 27.8599V18.7504C44.0166 18.7504 44.0176 18.7405 44.0176 18.7227V18.698C44.0156 18.5127 43.9628 17.8793 43.3678 17.441C43.0205 17.185 42.6775 17.105 42.3845 17.105C41.8978 17.1055 41.5495 17.3254 41.5495 17.3254Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;